document.addEventListener('DOMContentLoaded', function () {

  function removeQtyLimits(context = document) {
    context.querySelectorAll('input[name="quantity"]').forEach(input => {
      input.removeAttribute('max');
      input.removeAttribute('data-max');
      input.dataset.max = '';
    });
  }

  // Initial load
  removeQtyLimits();

  // After sliders / ajax load
  document.addEventListener('t4s:product_loaded', function (e) {
    removeQtyLimits(e.target);
  });

  document.addEventListener('t4s:section_loaded', function (e) {
    removeQtyLimits(e.target);
  });

  // Recently viewed & recommendations (async)
  setTimeout(() => removeQtyLimits(), 1000);
  setTimeout(() => removeQtyLimits(), 2500);

});
